import CtaBg from "../../images/faqs/cta-bg.png";

function FaqsCta() {
  return (
    <div className="cta">
      <img src={CtaBg} alt="bg" className="bg-image" />
      <h1 className="title">Quick enquiry? Send us an email</h1>
      <div className="form">
        <div className="fields">
          <p>Name</p>
          <input type="text" placeholder="John Doe" />
          <p>Phone</p>
          <input type="phone" placeholder="Your number" />
          <p>Email</p>
          <input type="email" placeholder="john@example.com" />
          <p>Message</p>
          <textarea placeholder="Your Enquiry" />
        </div>
        <button>
          <p>Send message</p>
          <div />
        </button>
      </div>
    </div>
  );
}

export default FaqsCta;
